import React, { memo } from 'react'
import Chat from 'supportAssistant/components/Chat/Chat'
import useChatListener from 'supportAssistant/hooks/useChatListeners'
import useChats from 'supportAssistant/hooks/useChats'

function ChatPage() {
  useChatListener()
  useChats()

  return <Chat />
}

export default memo(ChatPage)
